export const SceneKey = {
  Boot: "boot",
  Title: "title",
  PortalFfa: "portal-ffa",
  DropfrontSelect: "dropfront-select",
  Dropfront: "dropfront",
  ArtLab: "art-lab",
  Frontline: "frontline",
  RaidHub: "raid-hub",
  RaidSim: "raid-sim",
  RaidRoster: "raid-roster",
  RaidBattle: "raid-battle",
  NoiseExtraction: "noise-extraction",
  InfiniteWar: "infinite-war",
} as const;

export type SceneKey = (typeof SceneKey)[keyof typeof SceneKey];